import { useEffect, useState } from "react";
import PaymentService from '../../services/paymentService'

const useCard = (cashRegisterId) => {
    const [cardsTotals, setCard] = useState();
    const [cardsTotalsValids, setCardsTotalsValids] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const mapTotals = (totals) =>
            totals.reduce((total, curr) => ({
                ...total,
                fullIngress: total.fullIngress + curr.ingressTotal,
                fullEgress: total.fullEgress + curr.egressTotal,
                fullTotal: total.fullTotal + curr.total
    
            }), {
                cards: totals,
                fullIngress: 0,
                fullEgress: 0,
                fullTotal: 0
            });

        const getFromServer = async () => {
            setLoading(true);
            PaymentService
                .GetTotalsCards(cashRegisterId, { pageSize: 100, pageNumber: 1 })
                .then(res => {
                    setCard(mapTotals(res));
                    setCardsTotalsValids(mapTotals(res.filter(c => c.total && c.total !== 0 )));
                })
                .finally(() => setLoading(false))
        }
        if (!cardsTotals && cashRegisterId)
            getFromServer();
    }, [cardsTotals, cashRegisterId]);

    const edit = (value, cardId) => {
        cardsTotals.cards.find(p => p.id === cardId).subType = value;
        setCard({ ...cardsTotals });
    }

    return {
        cardsTotals,
        cardsTotalsValids,
        loading,
        edit
    }
}
export default useCard;